import * as React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {CoachInfoCard} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.eligibleForBonus');

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">
            {tt('heading', 'Eligible for Quick Start Bonus')}
          </Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          label={
            <Text>
              {tt('label.newOrderingEntities', 'New Ordering Entities')}
            </Text>
          }
          suffix={<LoadingBox style={styles.loadingBoxNewOrderingEntities} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          label={
            <Text>
              {tt(
                'label.qsbFrontlineQualifyingVolume',
                'QSB Frontline Qualifying Volume',
              )}
            </Text>
          }
          suffix={<LoadingBox style={styles.loadingBoxQsbFqv} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          label={
            <Text>
              {tt('label.qsbOrderingEntities', 'QSB Ordering Entities')}
            </Text>
          }
          suffix={<LoadingBox style={styles.loadingBoxQsbOrderingEntities} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          testID={CoachInfoCard.daysForEligibilityContent}
          style={{base: styles.listItem}}
          label={
            <Text>
              {tt('label.daysRemaining', 'Days Remaining for Eligibility')}
            </Text>
          }
          suffix={<LoadingBox style={styles.loadingBoxDaysRemaining} />}
        />
      </Gutter>
    </View>
  );
};
